// extracted by mini-css-extract-plugin
export default {"contentContainer":"PlayerList_contentContainer__33SwH","text":"PlayerList_text__KRkYu","container":"PlayerList_container__3OHui","itemsContainer":"PlayerList_itemsContainer__i1-Jw"};